"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const baseContent_1 = __importDefault(require("./baseContent/baseContent"));
const typesConstants_1 = require("../../constants/typesConstants");
const regularCall_1 = __importDefault(require("./regularCall/regularCall"));
const sendSMS_1 = __importDefault(require("./sendSMS/sendSMS"));
const spinner_1 = __importDefault(require("../spinner/spinner"));
const communicationBoxConstants_1 = require("./communicationBoxConstants");
const styles_1 = __importDefault(require("../../styles/styles"));
const actionsSlice_1 = require("../../features/actions/actionsSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const constants_1 = require("../../constants/constants");
const voipCall_1 = __importDefault(require("./voipCall/voipCall"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const CommunicationBox = ({ contacts, scheduleId, setCustomPhoneNumber, }) => {
    const dispatch = useAppDispatch_1.default();
    const [selectedContactIndex, setSelectedContactIndex] = react_1.useState(0);
    const { voipProvider, officerType } = useAppSelector_1.default((state) => ({
        voipProvider: state.auth.user.current_voip_provider,
        officerType: state.auth.user.officer_type,
    }));
    const userPhoneNumber = contacts[selectedContactIndex].phone_number;
    const isCustomerSupport = officerType === typesConstants_1.OFFICER_TYPES_CUSTOMER_SUPPORT;
    const loadingContent = (react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
        react_1.default.createElement(spinner_1.default, null)));
    let content = loadingContent;
    // TODO check why this happens on an array
    const selectedContact = contacts[selectedContactIndex]; // nosemgrep: javascript.lang.security.audit.detect-bracket-object-injection.detect-bracket-object-injection
    const flagAsDoNotCallHandler = () => {
        const payload = {
            scheduleId,
            selectedContact,
        };
        dispatch(actionsSlice_1.flagAsDoNotCall(payload));
    };
    const [contentKey, setContentKey] = react_1.useState(isCustomerSupport ? communicationBoxConstants_1.INBOUND_CALL : communicationBoxConstants_1.BASE);
    if (contentKey === communicationBoxConstants_1.LOADING) {
        content = loadingContent;
    }
    else if (contentKey === communicationBoxConstants_1.BASE) {
        content = (react_1.default.createElement(baseContent_1.default, { contacts: contacts, selectedContactIndex: selectedContactIndex, setSelectedContactIndex: setSelectedContactIndex, voipCall: () => setContentKey(communicationBoxConstants_1.VOIP_CALL), regularCall: () => setContentKey(communicationBoxConstants_1.REGULAR), sendSMS: () => setContentKey(communicationBoxConstants_1.SMS), inboundCall: () => setContentKey(communicationBoxConstants_1.INBOUND_CALL), flagAsDoNotCallHandler: flagAsDoNotCallHandler, setCustomPhoneNumber: setCustomPhoneNumber }));
    }
    else if (contentKey === communicationBoxConstants_1.VOIP_CALL && react_native_1.Platform.OS === constants_1.WEB_TAG) {
        content = (react_1.default.createElement(voipCall_1.default, { selectedContact: selectedContact, setBaseContent: () => setContentKey(communicationBoxConstants_1.BASE), userPhoneNumber: userPhoneNumber, scheduleId: scheduleId, voipCallProvider: voipProvider, feedback: !isCustomerSupport, sms: !isCustomerSupport }));
    }
    else if (contentKey === communicationBoxConstants_1.REGULAR) {
        content = (react_1.default.createElement(regularCall_1.default, { selectedContact: selectedContact, setBaseContent: () => setContentKey(communicationBoxConstants_1.BASE), scheduleId: scheduleId }));
    }
    else if (contentKey === communicationBoxConstants_1.SMS) {
        content = (react_1.default.createElement(sendSMS_1.default, { selectedContact: selectedContact, setBaseContent: () => setContentKey(communicationBoxConstants_1.BASE), scheduleId: scheduleId }));
    }
    return content;
};
exports.default = CommunicationBox;
